import { useRouteLoaderData } from "react-router-dom"
import AdminImagesShow from "../../components/admin/AdminImagesShow.jsx"
import { GetImage } from "../../repo/ImagesRepo.js"

export default function ImageShowPage() {
  const response = useRouteLoaderData('admin-image')

  return(
    <section className="m-8">
      {response && (
        <AdminImagesShow image={response}/>
      )}
    </section>
  )
}

export async function loader({ params, request }) {
  return await GetImage(params.id)
}
